export default __webpack_public_path__ + "static/media/barchart.f5afa6cc.svg";